import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getDataWithCategory, deleteIdData } from "../../../lib/appcheck"
import {getDataWithTypeForSelect} from '../../../lib/parameters'
import DropDown from "../../ui/dropdown";
//import Select from "react-select";

export default function AdminAppCheck() {

  const [parameters, setParameters] = useState([])
  const [category, setCategory] = useState(null);
  const [options, setOptions] = useState([]);


  const handleDelete = async (id) => {
    const choice = window.confirm(
      'Are You Sure?'
    );
    if (choice) {
      await deleteIdData(id);
      getDataWithTypeFromParamter();
      console.log("Delete", id);
      //router.refresh();
    }

  };

  async function getDataWithTypeFromParamter() {
    //const cats = await  getDataWithType("APPCHECK");
    //setCategory(cats);
    const slct = await  getDataWithTypeForSelect("APPCHECK");
    setOptions(slct);
    setCategory(slct[0]);
    getDatafromAppCheck(slct[0].id);
    //console.log("option",options);
  }

  async function getDatafromAppCheck(catg) {
    if (catg)
    {const params = await getDataWithCategory(catg);
    setParameters(params);}

  }


  useEffect(() => {
    getDataWithTypeFromParamter();
    //console.log("useEffect 1");
  }, [])


  



  useEffect(() => {
    //getDataWithCategory(category[0].id)
    //setPrivacy({ label: category[0].pname, value: category[0].id });
    /*
    category.map(function (cat) {
      options.push({ label: cat.pname, value: cat.id })
    })
    *//*
    setOptions([
      ...options,
      {
        key: window.crypto.randomUUID(),
        text,
        value
      }
    ]);
    */
    //console.log("privacy",privacy);
    if (category !== null)
      {
        
        getDatafromAppCheck(category.value);
      }
  }, [category])
  

  return (
            <div className="col-xl-9 col-md-8">
              <div className="settings-widget profile-details">
                <div className="settings-inner-blk p-0">
                  <div className="profile-heading">
                    <h3>Application Check</h3>
                    <div className="new-address">
                      <div className="row">
                        <div className="col">
                          <div className="mb-0">
                            <label className="form-label">
                             Category
                            </label>
                            <DropDown options={options}  setCategory = {setCategory} />
                               {/*
                             <Select
                                className=" select"
                                name="sellist1"
                                options={options}
                                defaultValue={options[0]}
                                placeholder="Choose"
                                onChange={setCategory}
                                styles={style}
                              ></Select>
                       
                            <select
                              className="select"
                              name="sellist1"
                              //options={options}
                              defaultValue={privacy}
                              placeholder="Choose"
                              onChange={e => setPrivacy(e.target.value)} 
                              style={style}
                            >
                              {category ? category.map(function (data) {
                                                        return (
                                                          <option  key={data.id} value={data.id}>{data.pname}</option>
                                                        )
                                                      }) : "" }

                            </select>
                                                    */}
                          </div>
                        </div>
                        <div className="col"> </div>
                        <div className="col">
                          <Link
                            to="/admin/admin-appcheck-edit/Add/0"
                            className="btn btn-dark btn-dark-1"
                          >
                            Create New Check
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="comman-space pb-0">
                    <div className="settings-invoice-blk table-responsive">
                      {/* Invoice info */}
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>Id</th>
                            <th>Question</th>
                            <th>Order</th>
                            <th>IsActive</th>
                            <th>&nbsp;</th>
                          </tr>
                        </thead>
                        <tbody>
                          {parameters.map(function (data) {
                            return (
                              <tr key={data.id}>
                                <td>
                                  <Link
                                    to="#"
                                    className="invoice-no"
                                  >
                                    {data.id}
                                  </Link>
                                </td>
                                <td>{data.question}</td>
                                <td>{data.order}</td>
                                <td>{data.isActive ? <span className="badge info-low">True</span> : <span className="badge info-high">False</span>}</td>
                                <td>
                                  <div className="profile-share d-flex align-items-center justify-content-end">
                                    <Link to={`/admin/admin-appcheck-edit/${data.id}/${category ? category.value : 0}`} className="btn btn-success btn-sm">
                                      Update  
                                    </Link>
                                    <button className="btn btn-danger btn-sm" onClick={() => handleDelete(data.id)}>
                                      Delete
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                      {/* Invoice info */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
  );
}
